// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBUSvVRJhiHyNp4S_8bP1HNbyJa_PhMGyc",
  authDomain: "ulempedotcom.firebaseapp.com",
  databaseURL: "https://ulempedotcom.firebaseio.com",
  projectId: "ulempedotcom",
  storageBucket: "ulempedotcom.appspot.com",
  messagingSenderId: "1074416078239",
  appId: "1:1074416078239:web:456c12139ce2a7028241aa",
  measurementId: "G-9PG523G5E4"
};

export default firebaseConfig
